import React, { useState } from 'react';
import { NewUpdateTransactionFormToggleWrapper, NEW_UPDATE_FORM_STORAGE_KEY } from 'feature-toggle';
import { Checkbox, Label } from 'shadcn-ui';
import { Header5 } from 'ui-builder';
import { Separator } from 'features/nekst-widgets';

function NewUpdateFormToggle() {
  const [enabled, setEnabled] = useState(
    () => localStorage.getItem(NEW_UPDATE_FORM_STORAGE_KEY) === 'true',
  );

  const handleChange = (checked: boolean) => {
    localStorage.setItem(NEW_UPDATE_FORM_STORAGE_KEY, String(checked));
    setEnabled(checked);
    window.location.reload();
  };

  return (
    <>
      <Separator />
      <Header5>New Update Transaction Form</Header5>
      <Label
        htmlFor="new-update-form-toggle"
        className="inline-flex items-center gap-2 cursor-pointer select-none text-sm text-foreground mb-0"
      >
        <Checkbox
          id="new-update-form-toggle"
          checked={enabled}
          onCheckedChange={(checked) => handleChange(!!checked)}
        />
        <span>Enable New Update Transaction Form (experimental)</span>
      </Label>
    </>
  );
}

export default function NewUpdateFormSettingsToggle() {
  return (
    <NewUpdateTransactionFormToggleWrapper>
      <NewUpdateFormToggle />
    </NewUpdateTransactionFormToggleWrapper>
  );
}
